/* eslint-disable */
import React, { useState } from "react";
import Body from "./Body";

const Revenue = () => {
  const [donutChartData, setDonutChartData] = useState([
    {
      classes: "Class 10",
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(20, 184, 166, 0.56)",
    },
    {
      classes: "Class 9",
      appearanceCount: 22,
      totalAttendee: 30,
      positionColor: "rgba(59, 130, 246, 0.56)",
    },
    {
      classes: "Class 8",
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(99, 102, 241, 0.56)",
    },
    {
      classes: "Class 7",
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(236, 72, 153, 0.56)",
    },
    {
      classes: "Class 6",
      appearanceCount: 7,
      totalAttendee: 30,
      positionColor: "rgba(245, 158, 11, 0.56)",
    },
    {
      classes: "Class 5",
      appearanceCount: 7,
      totalAttendee: 30,
      positionColor: "rgba(250, 204, 21, 0.56)",
    },
  ]);

  const [lineChartData, setLineChartData] = useState([
    {
      name: "Jan",
      revenue: 4000,
    },
    {
      name: "Feb",
      revenue: 3000,
    },
    {
      name: "Mar",
      revenue: 2000,
    },
    {
      name: "Apr",
      revenue: 2780,
    },
    {
      name: "May",
      revenue: 1890,
    },
    {
      name: "Jun",
      revenue: 2390,
    },
    {
      name: "Jul",
      revenue: 3490,
    },
    {
      name: "Aug",
      revenue: 2000,
    },
    {
      name: "Sept",
      revenue: 2780,
    },
    {
      name: "Oct",
      revenue: 1890,
    },
    {
      name: "Nov",
      revenue: 2390,
    },
    {
      name: "Dec",
      revenue: 3490,
    },
  ]);

  const _this = {
    donutChartData,
    lineChartData
  };
  return <Body {..._this} />;
};

export default Revenue;
